module.exports = __webpack_public_path__ + "Lato-Italic.e8894044bc84237cb48d.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Italic.woff
// module id = ../../../../../src/assets/fonts/Lato-Italic.woff
// module chunks = styles